export enum ReviewTab {
  Reviews = 'reviews',
  Questions = 'questions'
}

export interface TabItem {
  id: ReviewTab;
  title: string;
  count: number;
  emptyTitle: string;
}
